import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './user/context/AuthContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App /> {/* ✅ Make sure BrowserRouter is inside App */}
  </React.StrictMode>
  // <AuthProvider>
  //   <App />
  // </AuthProvider>
);
reportWebVitals();
